import { api_get, api_post } from "service/api";
import { toast } from "react-toastify";
import { Toast } from "components/Toast/Toast";

import * as types from "./actionsTypes";

const base = process.env.REACT_APP_URL;

async function resolvedInvoice(dispatch, form = {}) {
  const { rfc, webID, folio, date } = form;
  const url = `${base}/invoices?rfc=${rfc}&invoiceKey=${webID}&folio=${folio}&qid=${process.env.REACT_APP_QID_TEST}&date=${date}`;
  try {
    dispatch({ type: types.LOADING_DATA });
    const auth = {
      headers: { authorization: `${process.env.REACT_APP_TOKEN_TEST}` },
    };
    const res = await api_get(url, auth);
    dispatch({
      type: types.SUCCESSED_DATA,
      payload: { data: res, origin: form },
    });
  } catch (error) {
    dispatch({ type: types.FAILED_DATA, payload: error });
    toast.error(<Toast message={error} />, { theme: "colored" });
  }
}

async function resolvedStamp(dispatch, body) {
  const origin = process.env.REACT_APP_ORIGIN;
  const url = `${base}/invoices/income?&qid=${process.env.REACT_APP_QID_TEST}&origin=${origin}`;
  try {
    dispatch({ type: types.LOADING_STAMP });
    const auth = {
      headers: { authorization: `${process.env.REACT_APP_TOKEN_TEST}` },
    };
    const res = await api_post(url, body, auth);
    dispatch({ type: types.SUCCESSED_STAMP, payload: res });
  } catch (error) {
    dispatch({ type: types.FAILED_STAMP, payload: error });
    toast.error(<Toast message={error} />, { theme: "colored" });
  }
}

function resetLoadedData(dispatch) {
  dispatch({
    type: types.RESET_LOADED_DATA,
  });
}

function resetLoadedStamp(dispatch) {
  dispatch({
    type: types.RESET_LOADED_STAMP,
  });
}

export { resolvedInvoice, resolvedStamp, resetLoadedData, resetLoadedStamp };
